import React, { useRef, useState, useEffect } from 'react';
import AnimateHeight, { Height } from 'react-animate-height/dist/esm/index';

const AutoHeight = ({ children, ...props }: { children: React.ReactNode }) => {
  const [height, setHeight] = useState<Height>('auto');
  const contentDiv = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const element = contentDiv.current as HTMLDivElement;

    const resizeObserver = new ResizeObserver(() => {
      // Setting it to "auto" will remove the overflow: hidden property, which is needed for the animation to work
      // The overflow: hidden would cut off our tooltip content on availability
      setHeight(element.clientHeight > 0 ? 'auto' : 0);
    });

    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <AnimateHeight
      {...props}
      height={height}
      contentClassName='auto-content'
      contentRef={contentDiv}
      disableDisplayNone
    >
      {children}
    </AnimateHeight>
  );
};

export default AutoHeight;
